import ImmunizationCovidView from "./ImmunizationCovidView";

export default ImmunizationCovidView;
